import unset from 'lodash/unset'
import get from 'lodash/get'
import set from 'lodash/set'

export const TYPE_MULTIPLE_PROFILES_RM_USER = 'MultipleProfilesRemoveUser'
export const TYPE_LIVE_ACCESS_EMAIL_CAPTURE = 'LiveAccessEmailCapture'
export const TYPE_SECTION_FULL_DESCRIPTION = 'SectionFullDescription'
export const TYPE_SUBCATEGORY_DESCRIPTION = 'SubcategoryDescription'
export const TYPE_GIFT_CREATE_ACCOUNT = 'ModalGiftCreateAccount'
export const TYPE_FORGOT_PASSWORD = 'GlobalForgotPasswordModal'
export const TYPE_FREE_TRIAL_EXPIRED = 'modalFreeTrialExpired'
export const TYPE_UPDATE_PROFILE_IMAGE = 'UpdateProfileImage'
export const TYPE_INSTRUCTOR_BIO_VIDEO = 'InstructorBioVideo'
export const TYPE_SERIES_DESCRIPTION = 'SeriesDescription'
export const TYPE_LINK_SHARE = 'ModalLinkShare'
export const DIALOG_CLOSE_BUTTON_COLOR_WHITE = 'white'
export const TYPE_DAYTONA_WA_10 = 'ConfigurableVideo'
export const TYPE_CART_CHANGE_PLAN = 'ModalCartChangePlan'
export const TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM = 'ModalMyAccountChangePlanConfirm'
export const TYPE_MY_ACCOUNT_CHILD_PROFILE_CHANGE_PLAN = 'ModalMyAccountChildProfileChangePlan'
export const TYPE_MY_ACCOUNT_CANCEL_MEMBERSHIP = 'ModalMyAccountCancelMembership'
export const TYPE_MY_ACCOUNT_CANCEL_AI = 'ModalMyAccountCancelAI'
export const TYPE_HIDE_CONTENT = 'ModalHideContent'
export const TYPE_GIFT_CONFIRM = 'ModalGiftConfirm'
export const TYPE_PAUSE_RESUME = 'ModalPauseResume'
export const TYPE_PAUSE_ERROR = 'ModalPauseError'
export const TYPE_PORTAL_FLAG = 'modalPortalFlag'
export const TYPE_PORTAL_EXIT = 'modalPortalExit'
export const TYPE_SHARE_V2_SHARE = 'ShareV2Share'
export const TYPE_ROW_VIEW_ALL = 'RowViewAll'
export const TYPE_LOGIN = 'GlobalLoginModal'
export const TYPE_LOGIN_WITH_CODE = 'GlobalLoginWithCodeModal'
export const TYPE_CONFIRM = 'ModalConfirm'
export const TYPE_SHARE = 'Share'
export const TYPE_USER_PLAYLIST_ADD = 'PlaylistsAdd'
export const TYPE_USER_PLAYLIST_ADD_REMOVE = 'PlaylistsAddRemove'
export const TYPE_USER_PLAYLIST_DELETE = 'PlaylistsDelete'
export const TYPE_USER_PLAYLIST_RENAME = 'PlaylistsRename'
export const TYPE_USER_PLAYLIST_SHARE = 'PlaylistsShare'
export const TYPE_USER_PLAYLIST_TOOLTIP = 'PlaylistsTooltip'
export const TYPE_SELECT_GIFT_PLAN = 'SelectGiftPlan'
export const TYPE_CART_ABANDON = 'CartAbandon'
export const TYPE_COOKIE_COMPLIANCE = 'CookieCompliance'
export const TYPE_GIFT_PERIOD_NOTIFICATION = 'GiftPeriodNotification'
export const TYPE_SHARE_REDEEM = 'ShareRedeem'
export const TYPE_ANNOUNCEMENT_MODAL = 'Announcement'
export const TYPE_NOTIFICATION_VIDEO_PROMOTION = 'NotificationVideoPromotion'
export const TYPE_CHECKOUT_UPDATE_EMAIL = 'CheckoutUpdateEmail'
export const TYPE_COMMENT_REPORT = 'CommentReport'

let cache = {}

export function setProps (name, props) {
  set(cache, name, props)
}

export function clearProps (name) {
  if (name) unset(cache, 'name')
  else cache = {}
}

export function getProps (name) {
  return get(cache, name, {})
}
